export var uniqueElementsById = function (entities) {
    return entities.filter(function (entity, index, self) {
        return self.findIndex(function (e) { return e.id === entity.id; }) === index;
    });
};
//# sourceMappingURL=uniqueElementsById.js.map